import { Modal } from '@trackman/web-shared-components';

type Props = {
  open: boolean;
  onClose: (confirmed: boolean) => void;
};

export const DeleteConfirmationDialog = ({ open, onClose }: Props) => {
  const handleClose = () => onClose(false);
  const handleConfirm = () => onClose(true);

  return (
    <Modal
      className="admin-modal"
      open={open}
      title="Delete Selected Items"
      cancelBtn={{
        label: 'Cancel',
        onClick: handleClose,
      }}
      confirmBtn={{
        label: 'Delete',
        onClick: handleConfirm
      }}
      onClose={handleClose}
    >
      <div className="modal-body">
        Are you sure you want to delete the selected items? They will be moved to the trash.
      </div>
    </Modal>
  );
};
